<app-spinner [isLoading]="(isLoading$ | async)"></app-spinner>
<ng-container *ngIf="{
  selectedSpecializationsMap: selectedSpecializationsMap$ | async,
  specializationsTouched: specializationsTouched$ | async,
  atLeastOneSpecializationSelected: atLeastOneSpecializationSelected$ | async,
  localities: localities$ | async,
  selectedSpecializations: selectedSpecializations$ | async,
  formInitialValue: formInitialValue$ | async,
  isEditMode: isEditMode$ | async,
  jobseekerSubscriptionLookup: jobseekerSubscriptionLookup$ | async,
  jobseekerSubscriptionSpecializations: jobseekerSubscriptionSpecializations$ | async,
} as data">
  <div class="top-container">
    <h1 class="subscription-label">{{'label.Subscription' | translate}}</h1>
    <div class="help-text">
        <div [innerHTML]="'text.SubscriptionInfo' | translate"></div>
    </div>
    <form [formGroup]="subscriptionForm" #ngForm="ngForm" [appConnectForm]="data.formInitialValue"
      (ngSubmit)="onSubscribe(data.selectedSpecializations, data.isEditMode, data.code)">
      <div class="subscription-details-container">
        <div class="specializations-label">{{'label.Specialties' | translate}}</div>
        <div class="categories-container">
          <div *ngFor="let specialization of data.jobseekerSubscriptionSpecializations" class="categories-container__item">
            <mat-checkbox (change)="onToggleSpecialization(specialization, $event)"
              [ngModel]="data.selectedSpecializationsMap[specialization.id]" [ngModelOptions]="{standalone: true}">
              {{specialization.name}}</mat-checkbox>
          </div>
        </div>
        <mat-error  class="validation-message specialization-validation-message" *ngIf="(data.specializationsTouched || ngForm.submitted) && !data.atLeastOneSpecializationSelected">
          {{'message.SelectAtLeastOneSpecialty' | translate}}</mat-error>
        <div class="location-and-seniority">
        <div class="localities-container">
          <div class="localities-container__description">{{'text.SelectLocalitiesInfo' | translate}}</div>
          <div class="localities-container__input">
            <p-multiSelect
                [options]="data.jobseekerSubscriptionLookup?.locations"
                optionLabel="name"
                [placeholder]="'label.ChooseCity' | translate"
                [optionValue]="'id'"
                styleClass="dropdown-panel"
                [showToggleAll]="false"
                [panelStyleClass]="'dropdown-panel-style'"
                [appendTo]="'body'"
                formControlName="localities"
              >
                <ng-template let-item #item>
                  <span class="dropdown-item">{{ item.name }}</span>
                </ng-template>

                <ng-template pTemplate="selectedItems" let-selectedItems>
                  <ng-container *ngIf="selectedItems?.length < maxSelectedValue">
                    <div class="dropdown-selected-items">
                    <span *ngFor="let item of selectedItems; let last = last">{{
                      last ? item.name : item.name + ', '
                    }}</span>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="selectedItems?.length >= maxSelectedValue">
                    <span>
                      {{
                        'label.SelectedMultiselectOptions'
                          | translate: { count: selectedItems.length }
                      }}
                    </span>
                  </ng-container>
                </ng-template>
              </p-multiSelect>
          </div>
        </div>
        <div class="seniority-level-container">
          <div class="seniority-level-container__description">{{'label.SeniorityLevel' | translate}}</div>
          <div class="seniority-level-container__input">
            <p-multiSelect
                [options]="data.jobseekerSubscriptionLookup?.seniorityLevels"
                optionLabel="name"
                [placeholder]="'label.SeniorityLevel' | translate"
                [optionValue]="'id'"
                styleClass="dropdown-panel"
                [showToggleAll]="false"
                [panelStyleClass]="'dropdown-panel-style'"
                [appendTo]="'body'"
                formControlName="seniorityLevels"
              >
                <ng-template let-item #item>
                  <span class="dropdown-item">{{ item.name }}</span>
                </ng-template>

                <ng-template pTemplate="selectedItems" let-selectedItems>
                  <ng-container *ngIf="selectedItems?.length < maxSelectedValue">
                    <div class="dropdown-selected-items">
                    <span *ngFor="let item of selectedItems; let last = last">{{
                      last ? item.name : item.name + ', '
                    }}</span>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="selectedItems?.length >= maxSelectedValue">
                    <span>
                      {{
                        'label.SelectedMultiselectOptions'
                          | translate: { count: selectedItems.length }
                      }}
                    </span>
                  </ng-container>
                </ng-template>
              </p-multiSelect>
          </div>
        </div>
      </div>

      </div>
      <div class="button-container">
        <button class="button-container__item button-container__item--green"
          type="submit">{{'label.Save' | translate}}</button>
        <button (click)="onCancelSubscribe()" class="button-container__item button-container__item--grey"
          type="button">{{'label.Cancel' | translate}}</button>
      </div>
    </form>
  </div>
</ng-container>
